import { render, staticRenderFns } from "./LinkSaveForm.vue?vue&type=template&id=687099f1"
import script from "./LinkSaveForm.vue?vue&type=script&lang=js"
export * from "./LinkSaveForm.vue?vue&type=script&lang=js"
import style0 from "./LinkSaveForm.vue?vue&type=style&index=0&id=687099f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports